<script setup lang="ts">
useContextRefresh()
</script>

<template>
  <div class="auction-admin-layout">
    <Toolbar class="auction-admin-toolbar" />
    <main>
      <slot />
    </main>
  </div>
</template>

<style scoped>
.auction-admin-layout {
  min-height: 100dvh;
  font-family: 'Poppins', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
}

.auction-admin-toolbar {
  background: rgb(236 240 230);
}

html.dark .auction-admin-toolbar {
  background: rgb(0 70 96);
}
</style>
